import { createContext, PropsWithChildren, useContext } from 'react';
import { FormFieldProps } from './ContactUs.Interfaces';
import Consts from 'Interfaces/Consts';

const ContactUsContext = createContext<FormFieldProps | null>(null);

interface Props extends FormFieldProps, PropsWithChildren{}

const ContactUsFormField = (props: Props) => {

    const ctxtValue = {
        isRequired: false,
        inputType: 'text',
        classForInput: '',
        isVariable: false,
        ...props
    };

    return <div className={"mzFormGroup " + props.classForInput}>

        <ContactUsContext.Provider value={ctxtValue}>
            <div data-for={props.name} className="inp">
                {props.children}
            </div>
        </ContactUsContext.Provider>

    </div>
}


const TextArea = ({ className }: { className?: string }) => {

    const { componentId, label, name, inputValue, onChange, isRequired, onBlur } = useContext(ContactUsContext);

    return <textarea
        id={`${name}-${componentId}`}
        name={name}
        cols={10}
        rows={2}
        value={inputValue}
        onChange={onChange}
        onBlur={onBlur}
        className={className} //"input-border"
        aria-label={isRequired ? `${label} - ${Consts.requiredField}` : label} />
}

const Error = () => {

    const { error, name } = useContext(ContactUsContext);

    return <span className='mzErrorMessage field-validation-error'>
        <span id={`${name}-error`}>{error}</span>
    </span>
}

const Label = ({ className }: { className?: string }) => {

    const { componentId, isVariable, name, isRequired, label } = useContext(ContactUsContext);

    return <label
        htmlFor={`${name}-${componentId}`}
        className={`label mb-0 ${className} ${isVariable ? 'vari-label' : ''}`}>
        {
            isVariable ?
            <span dangerouslySetInnerHTML={{ __html: label + (isRequired ? "*" : "") }} /> :
            <span>{label}{isRequired ? '*' : ''}</span>
        }
    </label>
}

const Input = ({ className }: { className?: string }) => {
    const { inputType, name, componentId, inputValue, onChange, onBlur, isRequired, label } = useContext(ContactUsContext);
    return <input
        type={inputType}
        name={name}
        className={className} // "input-border dont-stretch" 
        id={`${name}-${componentId}`}
        value={inputValue}
        onChange={onChange}
        onBlur={onBlur}
        aria-label={isRequired ? `${label} - ${Consts.requiredField}` : label}
    />
}

ContactUsFormField.Input = Input;
ContactUsFormField.Error = Error;
ContactUsFormField.Label = Label;
ContactUsFormField.TextArea = TextArea;


export default ContactUsFormField;